import React from "react";
import { Modal } from "react-bootstrap";
import PanelUpgradeRoute from "../../../routes/panel-upgrade/PanelUpgradeRoute";

export default class PanelUpgradeModal extends React.PureComponent<{ showModal: boolean, closeModal: any }, {}> {


    render(): React.ReactNode {
        let { closeModal, showModal } = this.props;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title dir="rtl">
                        <div className="text-center">
                            امکانات ویژه
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ textAlign: 'center' }}>
                        <PanelUpgradeRoute />
                    </div>
                </Modal.Body >
                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}